import { urls } from 'constants/urls';
import { getFeatureFlags } from 'utils/featureFlags';

export const loginPagePath = () => {
  const url = getFeatureFlags()?.identity_enableOAuth2Web ? urls.loginOAuth2 : urls.login;

  return url;
};
